import { format } from 'date-fns'
import { toZonedTime } from 'date-fns-tz'

import { DEFAULT_TZ } from '@/constants/date'

export const formatDateTimeInTimezone = (
  timestamp: number,
  timezone: string = DEFAULT_TZ,
): string => {
  const zonedDate = toZonedTime(new Date(timestamp), timezone)
  return format(zonedDate, 'MM/dd/yyyy hh:mm aa')
}

export const formatTimeInTimezone = (timestamp: number, timezone: string = DEFAULT_TZ): string => {
  const zonedDate = toZonedTime(new Date(timestamp), timezone)
  return format(zonedDate, 'hh:mm a')
}

export const formatDatePartsInTimezone = (
  timestamp: number,
  timezone: string = DEFAULT_TZ,
): { day: string; month: string; time: string } => {
  const zonedDate = toZonedTime(new Date(timestamp), timezone)
  return {
    day: format(zonedDate, 'do'),
    month: format(zonedDate, 'MMMM'),
    time: format(zonedDate, 'hh:mm a'),
  }
}
